var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTherapyIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.72754 16.5H11.2275C14.9775 16.5 16.4775 15 16.4775 11.25V6.75C16.4775 3 14.9775 1.5 11.2275 1.5H6.72754C2.97754 1.5 1.47754 3 1.47754 6.75V11.25C1.47754 15 2.97754 16.5 6.72754 16.5Z",
    stroke: "#566875",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.47754 9.52508L5.97754 9.51008C6.54004 9.51008 7.17004 9.93758 7.38004 10.4626L8.23504 12.6226C8.43004 13.1101 8.73754 13.1101 8.93254 12.6226L10.65 8.26508C10.815 7.84508 11.1225 7.83008 11.3325 8.22758L12.1125 9.70508C12.345 10.1476 12.945 10.5076 13.44 10.5076H16.485",
    stroke: "#566875",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTherapyIcon);
export default __webpack_public_path__ + "static/media/therapy_icon.b801f04fd8c758be5627c1f6df18f10f.svg";
export { ForwardRef as ReactComponent };